import React from "react";
import { FacebookShareButton, TwitterShareButton } from "react-share";

import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import Button from "src/components/UI/Button";
const SocialShare = ({ socials }) => {
  return (
    <Grid
      justifyContent={["center", null, null, null, null, "flex-start"]}
      flexDirection="row"
    >
      {socials.facebook && (
        <Column
          width={[1, null, null, null, 6 / 12, 6 / 12]}
          style={{ maxWidth: "290px" }}
          mb={[2, null, 0]}
        >
          <FacebookShareButton
            style={{ width: "100%" }}
            url={socials.facebook.url}
            className="button"
          >
            <Button label={socials.facebook.label} width={1} filled="facebook">
              {socials.facebook.label}
            </Button>
          </FacebookShareButton>
        </Column>
      )}
      {socials.twitter && (
        <Column
          width={[1, null, null, null, 6 / 12, 6 / 12]}
          style={{ maxWidth: "290px" }}
          mb={[4, null, 0]}
        >
          <TwitterShareButton
            style={{ width: "100%" }}
            url={socials.twitter.url}
            className="button"
          >
            <Button label={socials.twitter.label} width={1} filled="twitter">
              {socials.twitter.label}
            </Button>
          </TwitterShareButton>
        </Column>
      )}
    </Grid>
  );
};

export default SocialShare;
